export const userColumns = [
    { field: "_id", headerName: "ID", width: 230 },
    {
        field: "username",
        headerName: "Username",
        width: 300,
      },
    {
      field: "email",
      headerName: "Email",
      width: 300,
    }
  ];